/*
 * 25-sep-2026 (orden de Jorge): cobros PAUSADOS en todos los proyectos hasta el alta de autónomo.
 * Con false, los botones de pago muestran «Avísame cuando abra» (src/components/AvisameForm.jsx)
 * y no llaman a /api/checkout.
 * El backend tiene su propio interruptor (env COBRO_ACTIVO=true en Railway para reabrir); si la
 * web dice true pero el servidor no, el 503 COBRO_PAUSADO también abre el formulario de aviso.
 * Para reabrir: poner true aquí, COBRO_ACTIVO=true en Railway y redesplegar ambos.
 *
 * CommonJS (como faqPrecios.js) para que scripts/prerender-seo.js pueda leerlo y el HTML
 * estático de /precios diga lo mismo que la página.
 */
const COBRO_ACTIVO = false;

module.exports = { COBRO_ACTIVO };
